<div clas="col-md-6 col-sm-12">
    <div class="card">
        <h3 class="h3-responsive card-header view gradient-card-header blue-gradient white-text">Dashboard</h3>
        <div class="card-body">
            <p> Welcome to your dashboard. Listed below are the assignments your clinician has given you to work on. </p>
            <div *ngIf="!hasAssessments">
                <p>It doesn't look like you have been given any assignments to work on. Please contact customer support using
                    the contact information at the bottom of this screen</p>
                <logout></logout>
            </div>
            <div *ngIf="assessmentsCompleted">
                <p>Congratulations all of your assignments are complete and have been submitted to your clinician. You can now logout.</p>
                <logout></logout>
            </div>
            <div *ngIf="hasAssessments && !assessmentsCompleted">
                <div>
                    <input *ngIf="assessmentsStarted" type="button" class="btn btn-primary" [routerLink]="['../take', getNextTest()]"
                        value="Continue with your assignments" />
                    <input *ngIf="!assessmentsStarted" type="button" class="btn btn-primary" [routerLink]="['../take', getNextTest()]"
                        value="Get started" />
                    <logout></logout>
                </div>
            </div>

            <p *ngIf="loadingAssessments" class="alert alert-warning">
                <app-spin-icon></app-spin-icon> Loading assignment information...
            </p>
            <ul class="list-group col-sm-12 col-md-6">
                <li class="list-group-item flex-column align-items-start" *ngFor="let assignment of assignments">
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{{assignment.Name}}</h5>
                        <small>
                            Assigned: {{assignment.DateAssigned | date: 'shortDate'}}
                            <span *ngIf="assignment.type != 'AssessmentGroup' && assignment.IsComplete" class="badge badge-primary badge-pill"><i
                                    class='fa fa-check-circle'></i></span>
                            <span *ngIf="assignment.type != 'AssessmentGroup' && !assignment.IsComplete" class="badge badge-danger badge-pill"><i
                                    class='fa fa-clock-o'></i></span>
                        </small>
                    </div>
                    <ul *ngIf="assignment.type == 'AssessmentGroup'" class='list-group list-group-flush'>
                        <li *ngFor="let item of assignment.Items" class='list-group-item'>
                            <span *ngIf="item.IsComplete" class="badge badge-primary badge-pill"><i class='fa fa-check-circle'></i></span>
                            <span *ngIf="!item.IsComplete" class="badge badge-danger badge-pill"><i class='fa fa-clock-o'></i></span>
                            {{item.name}}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/assessments/dashboard/dashboard.component.html